import { useMemo } from 'react';
import type { DatadogInterface } from '../utilities/dataDog';
import { datadogInterface } from '../utilities/dataDog';
import useAccountModal from '../hooks/useAccountModal';
import type { AccountModalState } from '../hooks/useAccountModal';
import type { AuthContextType } from './AuthProvider';
import { useAuth } from './AuthProvider';

type MfeInterface = {
  setUnauthorized: () => void;
  datadog: DatadogInterface;
  useAuth: () => AuthContextType;
  useAccountModal: (
    app: string,
    component: string
  ) => {
    signIn: (handleSuccess?: Function, handleError?: Function, state?: AccountModalState) => void;
  };
};

const useMfeInterface = (): MfeInterface => {
  const { setUnauthorized } = useAuth();

  return useMemo(
    () => ({
      setUnauthorized: () => {
        setUnauthorized(true);
      },
      datadog: datadogInterface,
      useAccountModal,
      useAuth
    }),
    [setUnauthorized]
  );
};

export default useMfeInterface;
